import * as React from 'react'
import { Divider as MuiDivider } from '@material-ui/core'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'
import get from 'lodash/get'

type Props = {
  color: CustomThemePalette
  edgeType: 'square' // we can define other types of edge
}
export const Divider: React.FC<Props> = ({ color, edgeType }) => {
  return (
    <Row>
      <Edge type={edgeType} color={color} />
      <Border color={color} />
      <Edge type={edgeType} color={color} />
    </Row>
  )
}

type EdgeProps = {
  type: 'square'
  color: CustomThemePalette
}
const Edge: React.FC<EdgeProps> = ({ type, color }) => {
  const { palette } = useTheme()
  if (type === 'square') {
    const colorCode = get(palette, color.split('.'), 'common.black')

    return (
      <BorderedRectangle color={colorCode}>
        <Rectangle color={colorCode} />
      </BorderedRectangle>
    )
  }
  // Define the component.
  else return null
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const Border = props => {
  const { palette } = useTheme()
  const color = get(palette, props.color.split('.'), 'common.black')
  const s = useStyles({ color })
  return <MuiDivider className={s.divider} />
}

const BorderedRectangle = styled.div<{ color: CustomThemePalette }>(
  ({ color }) => `
  border: 1px solid ${color};
  transform: rotate(45deg);
  box-sizing: border-box;
  width: 8px;
  height: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`
)

const Rectangle = styled.div<{ color: CustomThemePalette }>(
  ({ color }) => `
  background: ${color};
  width: 4px;
  height: 4px;
`
)

type StyleProps = {
  color: string
}
const useStyles = makeStyles(() => ({
  divider: (props: StyleProps) => ({
    flex: 1,
    marginLeft: 5,
    marginRight: 5,
    background: 'none',
    height: 1,
    borderTop: `1px dashed ${props.color}`,
  }),
}))
